import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { compose, setDisplayName, setPropTypes } from 'react-recompose';
import styled from 'styled-components';

import { Label } from 'semantic-ui-react';

import { fetchSSOProviders } from './operations';
import withReduxDataLoading, { withLoadingBranch } from '~/views/enhancers/withReduxDataLoading';

import Section from '~/views/common/Section';


const ProviderList = styled.ul`
    list-style: none;
`;

const ProviderItem = styled.li`
    margin-right: 5px;
    margin-bottom: 5px;
`;


export const SSO = ({ providers = [] }) => (
    <Section name="SSO" >
        { providers.length ? (
            <ProviderList>
                { providers.map(({ id, type, name }) => (
                    <ProviderItem key={id}>
                        <Label content={type} detail={name} />
                    </ProviderItem>
                )) }
            </ProviderList>
        ) : (
            <div>Not Configured</div>
        ) }
    </Section>
);


SSO.propTypes = {
    providers: arrayOf(shape({
        id: string.isRequired,
        type: string.isRequired,
        name: string.isRequired,
    }).isRequired),
};

export default compose(
    setDisplayName('SSOContainer'),
    setPropTypes({
        id: string.isRequired,
    }),
    withReduxDataLoading({
        name: 'fetchSSOProviders',
        operation: ({ id }) => fetchSSOProviders(id),
        dataName: 'providers',
    }),
    withLoadingBranch,
)(SSO);
